import BaseWrapper from "../../../components/ui/BaseWrapper";

const PlatformUsersHeader = () => {
  return (
    <div className="border-b border-zinc-300 bg-white ">
      {/* <BaseWrapper>
        <div className="grid grid-cols-7 gap-y-3 py-[7px] items-center">
          <div className="md:col-span-3 col-span-7">
            <h3 className=" md:text-left text-center">Engineers</h3>
          </div>
          <div className="md:col-span-4 col-span-7 flex justify-end">
            <button className="bg-primary font-light text-sm text-white px-3 py-1.5 rounded shadow hover:bg-primary/90 transition">
              Invite Engineer
            </button>
          </div>
        </div>
      </BaseWrapper> */}
    </div>
  );
};

export default PlatformUsersHeader;
